var webooker_courses_models = webooker_courses_models || {};

(function (ns) {

    // #region CourseRegistration - ctor

    ns.CourseRegistration = function CourseRegistration(dto /* Webooking.Common.Model.CourseRegistrationDTO */) {

        this.courseRegistrationID = dto.courseRegistrationID;
        this.courseID = dto.courseID;
        this.studentID = dto.studentID;
        this.studentName = dto.studentName;
        this.studentSurname = dto.studentSurname;
        this.studentMiddleName = dto.studentMiddleName;
        this.studentBirthday = dto.studentBirthday;
        this.price = dto.price;
        this.payments = _.transform((dto.payments || []), function (result, p) {
            result.push(new ns.courseRegistrationPayment(p));
        }, []);

        // Copy orig array without transforming it to js model
        // The transformation happens in the initialize method
        this.registeredAttendance = (dto.registeredAttendance || []).slice();

        this.contactPhone = dto.contactPhone || null;
        this.contactEmail = dto.contactEmail || null;
        this.registrationDate = dto.registrationDate;
        this.notes = dto.notes;
        this.notificationSent = dto.notificationSent;
        this.preAmendsCount = dto.preAmendsCount;
        this.timeBoundAmendCount = dto.timeBoundAmendCount;
        this.timeBoundAmendExpiration = dto.timeBoundAmendExpiration;
        this.attendantHealth = dto.attendantHealth;
        this.parentFullName = dto.parentFullName || null;
        this.parentID = dto.parentID || 0;
        this.tenantID = dto.tenantID;

        // Assign without transforming it to js model
        // The transformation happens in the initialize method
        this.invoice = dto.invoice;
        this.invoiceID = dto.invoiceID;

        this.semesterID = dto.semesterID;
        this.semesterName = dto.semesterName;
        this.courseFullName = dto.courseFullName;
        this.firstDate = dto.firstDate;
        this.allowMultiAttendance = dto.allowMultiAttendance;
        this.reservedPlaces = dto.reservedPlaces;
        this.health = dto.health || null;
        this.selfAssessedProficiencyLevelID = dto.selfAssessedProficiencyLevelID;
        this.paymentsSum = dto.paymentsSum;
        this.arrear = dto.arrear;
        this.studentFullName = dto.studentFullName;
        this.studentAge = dto.studentAge;
        this.smsCode = dto.smsCode;


        // ---------------------------- Non DTO properties ----------------------------
        this.isNew = !!dto.isNew;
        this.attend = !!dto.attend;


        this.$initialized = false;

    };

    // #endregion

    // TODO: CreateNew Async!

    // #region CourseRegistration - methods

    // course { 
    //  price: 0, 
    //  fixedPrice: 0, ,
    //  remainingLessons: 0, 
    //  scheduleWithAttendance: [ 
    //      { 
    //          courseScheduleID: 0,
    //          attendance: [ { studentID: 0, courseAttendanceFeeType: 0 } ]
    //      } 
    //  ] }
    // Returns: promise
    ns.CourseRegistration.prototype.initialize = function (
        $q,
        invoiceSvc,
        promotionSvc,
        attendanceSvc,
        coursePriceSvc,
        course,
        isAction,
        isAdmin,
        doNotPreselect) {
        
        var self = this;

        self.$initialized = true;
        self.$allowClientLessonSelection = course.allowClientLessonSelection;

        return $q(function (resolve, reject) {

            self.attend = !self.isNew;

            var promises = [];

            var invoice = null;
            if (self.courseRegistrationID) {
                invoice = invoiceSvc.getLatestByCourseRegistration(self.courseRegistrationID);
                promises.push(invoice.$promise);
            } else {
                invoice = {
                    lineItems: []
                };
            }

            var promotionNow = self.registrationDate || new Date();
            var studentPromotionNow = promotionNow;
            
            if (self.registeredAttendance.length) {
                var registeredLessons = _.sortBy(_.filter(self.registeredAttendance, { courseAttendanceType: 0 }), 'startDate');

                if (registeredLessons.length) {
                    promotionNow = registeredLessons[0].startDate;
                    studentPromotionNow = promotionNow;
                }

               // var filteredRegisteredLessons = _.filter(registeredLessons, { courseAttendanceType: 0 });
               // if (filteredRegisteredLessons && filteredRegisteredLessons.length) {
               //     studentPromotionNow = filteredRegisteredLessons[0].startDate;
               // } else {
               //     studentPromotionNow = promotionNow;
            //    }
            }

            var promotions = null;
            var attendance = null;
            if (self.parentID && self.studentID) {
                promotions = promotionSvc.getPromotionsByStudentsAsync(
                    self.parentID, [{ studentID: self.studentID }], !!isAction ? 'action' : 'course', promotionNow, studentPromotionNow, isAdmin);
                promises.push(promotions.$promise);

                attendance = attendanceSvc.getStudentCourseAttendanceByUser(self.courseID, self.studentID, self.parentID, true);
                promises.push(attendance.$promise);
            }

            $q.all(promises).then(function () {

                var attModels = [];

                angular.forEach(self.registeredAttendance, function (ra) {
                    attModels.push(new webooker_courses_models.CourseRegistrationAttendance(ra))
                });

                self.registeredAttendance.length = 0;
                self.registeredAttendance.push.apply(self.registeredAttendance, attModels);

                if (attendance) {
                    var mnow = moment();
                    var attMap = _.zipObject(_.map(attendance, 'courseScheduleID'), attendance);
                    _.forEach(self.registeredAttendance, function (ra) {
                        var courseScheduleID = ra.courseScheduleID;
                        var att = attMap[courseScheduleID];
                        if (att) {
                            ra.courseAttendanceType = att.attendanceType;
                            ra.courseAttendanceStatus = att.attendanceStatus;
                            ra.oldCourseAttendanceType = att.attendanceType;
                            ra.oldCourseAttendanceStatus = att.attendanceStatus;
                            ra.attendanceCount = att.attendanceCount;
                        }

                        if (!ra.isDisabled && !self.courseRegistrationID && moment(ra.startDate).isAfter(mnow) && !doNotPreselect) {
                            ra.isRegistered = true;
                        }
                    });
                }

                self.invoice = new webooker_courses_models.CourseRegistrationInvoice(
                    coursePriceSvc,
                    course,
                    self.registeredAttendance,
                    !!promotions ? promotions[self.studentID] || [] : [],
                    invoice);

                self.invoice.$courseRegistration = self;

                if (isAction && !!self.registeredAttendance && !!self.registeredAttendance.length) {
                    self.reservedPlaces = self.registeredAttendance[0].attendanceCount;
                    
                    self.$attend = !self.isNew && self.registeredAttendance[0].courseAttendanceStatus === 0;
                }

                resolve(self);

            }, reject);
        });
    }

    ns.CourseRegistration.prototype.preInitNew = function (
        $q,
        courseScheduleSvc,
        course,
        isAction,       
        doNotPreselect)
    {
        var self = this;

        return $q(function (resolve, reject) {

            self.isNew = true;
            self.courseID = course.courseID,
            self.registrationDate = new Date();
            self.preAmendsCount = course.preAmendsCount;
            self.timeBoundAmendCount = course.timeBoundAmendCount;
            self.timeBoundAmendExpiration = course.timeBoundAmendExpiration;
            self.allowMultiAttendance = course.allowMultiAttendance;
            self.reservedPlaces = 1;

            var mnow = moment();

            courseScheduleSvc.getAllAsync(course.courseID).$promise.then(
                function (schedules) {

                    _.forEach(schedules, function (schedule) {
                        var isRegistered = !!isAction
                            ? true
                            : moment(schedule.startDate).isAfter(mnow);

                        if (doNotPreselect) {
                            isRegistered = false;
                        }

                        self.registeredAttendance.push({
                            courseScheduleID: schedule.courseScheduleID,
                            startDate: schedule.startDate,
                            endDate: schedule.endDate,
                            isRegistered: isRegistered,
                            courseAttendanceType: isRegistered ? 0 : null,   // 0 - Registered,  1 - OneOff, 2 - Amend, 3 - Preview
                            courseAttendanceStatus: isRegistered ? 0 : null, // 0 - Present, 1 - NotPresentNotExcused, 2 - NotPresentExcused, 3 - NotPresentExcusedNoCompensation
                            attendanceNotes: null,
                            attendanceCount: 1
                        });
                    });

                    resolve(self);

                }, reject);
        });
    }
    
    ns.CourseRegistration.prototype.toJSON = function () {
        return {
            courseRegistrationID: this.courseRegistrationID,
            courseID: this.courseID,
            studentID: this.studentID,
            studentName: this.studentName,
            studentSurname: this.studentSurname,
            studentMiddleName: this.studentMiddleName,
            studentBirthday: this.studentBirthday,
            price: this.price,
            payments: this.payments,
            registeredAttendance: this.registeredAttendance,
            contactPhone: this.contactPhone,
            contactEmail: this.contactEmail,
            registrationDate: this.registrationDate,
            notes: this.notes,
            notificationSent: this.notificationSent,
            preAmendsCount: this.preAmendsCount,
            timeBoundAmendCount: this.timeBoundAmendCount,
            timeBoundAmendExpiration: this.timeBoundAmendExpiration,
            attendantHealth: this.attendantHealth,
            parentFullName: this.parentFullName,
            parentID: this.parentID,
            tenantID: this.tenantID,
            invoice: this.invoice,
            semesterID: this.semesterID,
            semesterName: this.semesterName,
            courseFullName: this.courseFullName,
            firstDate: this.firstDate,
            allowMultiAttendance: this.allowMultiAttendance,
            reservedPlaces: this.reservedPlaces,
            health: this.health,
            selfAssessedProficiencyLevelID: this.selfAssessedProficiencyLevelID,
            paymentsSum: this.paymentsSum,
            arrear: this.arrear,
            studentFullName: this.studentFullName,
            studentAge: this.studentAge,
            smsCode: this.smsCode
        }
    }


    ns.CourseRegistration.prototype.markErrorAttendance = function (scheduleIDs) {

        var scheduleIDsNormalized = scheduleIDs || [];

        _.forEach(this.registeredAttendance, function (a) {
            if (scheduleIDsNormalized.indexOf(a.courseScheduleID) === -1) {
                a.$hasError = false;
            } else {
                a.$hasError = true;
            }
        });
    }

    ns.CourseRegistration.prototype.updateCapacityByRefreshedSchedules = function (schedules) {

        var scheduleMap = _.zipObject(_.map(schedules, 'courseScheduleID'), schedules);

        _.forEach(this.registeredAttendance, function (a) {
            var newSchedule = scheduleMap[a.courseScheduleID];

            a.updateCapacityByRefreshedSchedule.call(a, newSchedule);
        });
    }

    // #endregion


    // #region CourseRegistration - properties

    // Does not overbook capacity
    Object.defineProperty(ns.CourseRegistration.prototype, 'isAllNewSelected', {
        enumerable: true, configurable: true,
        get: function () {
            var res = _.reduce(this.registeredAttendance, function (res, a) {
                return res && (a.isUserEditable ? a.isRegistered : true);
            }, true);

            return res && !!_.find(this.registeredAttendance, { isUserEditable: true, isRegistered: true }) && this.isNew;
        }, 
        set: function (value) {
            _.forEach(this.registeredAttendance, function (a) {
                if (a.isUserEditable) {
                    a.isRegistered = value;
                }
            });
        }
    });

    Object.defineProperty(ns.CourseRegistration.prototype, 'isAnySelected', {
        enumerable: true, configurable: true,
        get: function () {
            return _.reduce(this.registeredAttendance, function (res, a) {
                return res || (a.isUserEditable && a.isRegistered);
            }, false) && this.isNew;
        }
    });

    Object.defineProperty(ns.CourseRegistration.prototype, 'isAnySelectable', {
        enumerable: true, configurable: true,
        get: function () {
            return _.find(this.registeredAttendance, { isUserEditable: true });
        }
    });
    
    Object.defineProperty(ns.CourseRegistration.prototype, 'attend', {
        enumerable: true, configurable: true,
        get: function () {
            return this.$attend || (this.isAnySelected && !!this.$allowClientLessonSelection);
        },
        set: function (value) {
            this.$attend = value;
        }
    });

    Object.defineProperty(ns.CourseRegistration.prototype, 'actionAttendanceStatus', {
        enumerable: true, configurable: true,
        get: function () {
            if (!!this.registeredAttendance && !!this.registeredAttendance.length) {
                return this.registeredAttendance[0].courseAttendanceStatus;
            }
            
            return 0;
        }
        
    });

    Object.defineProperty(ns.CourseRegistration.prototype, 'isInThePast', {
        enumerable: true, configurable: true,
        get: function () {
            return _.reduce(this.registeredAttendance, function (res, a) {
                return res && a.isInThePast;
            }, true);
        }
    });

    // Overpayment is not included here, so it is not a real arrear but rather
    // what should be your next payment
    Object.defineProperty(ns.CourseRegistration.prototype, 'arrearByAmortizationSchedule', {
        enumerable: true, configurable: true,
        get: function () {      
            if (!!this.invoice) {
                return Math.max(this.invoice.totalByamortizationSchedule - this.paymentsSum, 0);
            }
            return 0;
        }
    });

    // #endregion


})(webooker_courses_models);